// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2FPmo","buttons":"RemoveExpirationActionButtons_buttons__4-1KO"};